import { environment } from 'config/environment';

/**
 *
 * @returns {string}
 */

export const getEnv = (key: string): string => {
  return environment[key];
};

export const getAudience = (): string => {
  return environment.AUDIENCE;
};

export const getApiUrl = (): string => {
  return environment.API_URL;
};
